import { cn } from "@/lib/utils";

export const HopeifierLogo = ({ size = 24, className = "" }) => (
    <img
        src="img/pwa-icon/i-icon-bg-transparent.svg"
        className={cn("", className)}
        width={size}
        height={size}
    />
);